import { render, staticRenderFns } from "./SendReminderDialog.vue?vue&type=template&id=52a428ea&v-slot%3Amodal-body=true&"
import script from "./SendReminderDialog.vue?vue&type=script&lang=js&"
export * from "./SendReminderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports